var __extends = (this && this.__extends) || (function () {
    var extendStatics = function (d, b) {
        extendStatics = Object.setPrototypeOf ||
            ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
            function (d, b) { for (var p in b) if (Object.prototype.hasOwnProperty.call(b, p)) d[p] = b[p]; };
        return extendStatics(d, b);
    };
    return function (d, b) {
        if (typeof b !== "function" && b !== null)
            throw new TypeError("Class extends value " + String(b) + " is not a constructor or null");
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import React from "react";
import { onErrorImgHandler } from "./styles";
var GameThumbnail = /** @class */ (function (_super) {
    __extends(GameThumbnail, _super);
    function GameThumbnail() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    GameThumbnail.prototype.render = function () {
        var _a = this.props.game || {}, _b = _a.ThumbnailUrl, ThumbnailUrl = _b === void 0 ? "" : _b, _c = _a.Name, Name = _c === void 0 ? "" : _c;
        return (ThumbnailUrl || "").endsWith(".mp4") ? (_jsx("video", __assign({ preload: "none", autoPlay: true, muted: true, loop: true, playsInline: true, controlsList: "nofullscreen", controls: false, className: "game-thumbnail" }, { children: _jsx("source", { src: ThumbnailUrl, type: "video/mp4" }) }))) : (_jsx("img", { loading: "lazy", decoding: "async", src: ThumbnailUrl, alt: "Game ".concat(Name), className: "game-thumbnail", onError: onErrorImgHandler }));
    };
    return GameThumbnail;
}(React.Component));
export default GameThumbnail;



// WEBPACK FOOTER //
// ./src/components/games/components/GameThumbnail.jsx